import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpEventType,
  HttpErrorResponse,
  HttpHeaders,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { switchMap, map, catchError, filter } from 'rxjs/operators';
import { ApiServerService } from './api-server.service';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  constructor(
    private http: HttpClient,
    private apiService: ApiServerService,
  ) { }

  // Метод для загрузки файла
  uploadFilePresign(file: File): Observable<string> {
    // Сначала получаем presigned URL с backend
    return this.getPresignedUrl(file.name, file.type).pipe(
      switchMap((presignData: any) => {
        const presignedUrl = presignData.url;
        const key = presignData.key;

        // Загружаем файл на S3 используя presigned URL
        return this.http.put(presignedUrl, file, {
          headers: new HttpHeaders({
            'Content-Type': file.type
          }),
          reportProgress: true,
          observe: 'events'
        }).pipe(
          filter(event => event.type === HttpEventType.Response),
          map(event => {
            console.log(event);
            // Возвращаем URL загруженного файла
            const s3Url = `https://your-s3-bucket.s3.amazonaws.com/${key}`;
            return s3Url;
          }),
          catchError((error: HttpErrorResponse) => {
            console.error('Ошибка при загрузке файла', error);
            return throwError(() => new Error('Ошибка при загрузке файла'));
          })
        );
      })
    );
  }

  uploadFileDirect(file: File): Observable<HttpEvent<any>> {
    const formData = new FormData();
    formData.append('file', file);

    return this.apiService.POST<any>('files', formData, {
      reportProgress: true,
      observe: 'events',
    });
  }


  deleteFile(fileId: number): Observable<any> {
    return this.apiService.DELETE<any>(`files/${fileId}`);
  }

  // Метод для получения presigned URL
  private getPresignedUrl(filename: string, contentType: string): Observable<any> {
    return this.apiService.GET<any>('files/presign', `filename=${filename}&contentType=${contentType}`);
  }
}
